export default __webpack_public_path__ + "media/images/more-b4ad9308b0f253f2a828bd37b5313125.svg";